module.exports = {"450326100":"永福镇","450326101":"罗锦镇","450326102":"百寿镇","450326103":"苏桥镇","450326104":"三皇镇","450326105":"堡里镇","450326202":"广福乡","450326204":"永安乡","450326205":"龙江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450326.json
// module id = 1928
// module chunks = 0